<script setup lang="ts">
import * as _MBOCDC from '@mbo/cdc-dependencies-resolver'
import { useI18n } from 'vue-i18n'
import type { ResolverProps } from '@/types/dependenciesResolver.interface'

const cdcProps: ResolverProps = (window as any).xprops

const { locale } = useI18n()
locale.value = cdcProps.context.locale
</script>

<template>
  <slot></slot>
</template>
